import React, { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  const navigate = useNavigate()
  return (
    <div
      className={`nc-SectionHero relative ${className} mb-20 lg:mb-36`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col  gap-12 lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="flex-grow">
          <img className="w-full  rounded-xl" src={rightImg} alt="" />
        </div>
        <div className="w-screen max-w-full  space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-[#3B3B3B] md:text-4xl xl:text-5xl dark:text-neutral-100">
            Your Trusted Car<br/> <span className="text-primary-100">Rental Partner</span> 
          </h2>
          <span className="block !font-semibold xl:text-lg text-[#1B2430] dark:text-neutral-400">
            {subHeading}
          </span>
          {<ButtonPrimary onClick={()=>{navigate("/contact")}} >Contact Us</ButtonPrimary>}
        </div>

      </div>
    </div>
  );
};

export default SectionHero;
